import styled from 'styled-components'
import './simpleLoader.css'

const LoadingContainer = styled.div<{ $visible?: boolean }>`
    transition: opacity: 0.3s ease-in-out;
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
`
export const SimpleLoader = ({ visible = true }: { visible?: boolean }) => {
    return (
        <LoadingContainer className="lds-ellipsis" $visible={visible}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </LoadingContainer>
    )
}
